import { ApiStatus } from "../types/api/status"
import { useDispatch, useSelector } from "../redux/store"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { changeStatus, onSetSelectedTypeProduct, selectTypeProductState, setAction } from "../redux/slices/typeProductSlice"
import { TypeProductAPI } from "../apis/TypeProductAPI"
import { typeProduct } from "../types/slices/typeProductType"

export const useTypeProductStore = () => {

    const dispatch = useDispatch()
    const { typeProducts, typeProductSelected, status, action } = useSelector(selectTypeProductState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const getTypeProducts = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await TypeProductAPI.getTypeProducts({search:search})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createTypeProduct = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await TypeProductAPI.createTypeProduct({...data, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const editTypeProduct = async (idbranchoffice: number, data: any) => {
        try {
        dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await TypeProductAPI.editTypeProduct(idbranchoffice, {...data, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const deleteTypeProduct = async (idbranchoffice: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await TypeProductAPI.deleteTypeProduct(idbranchoffice)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedTypeProduct = (type: typeProduct) => {
        try {
            dispatch(onSetSelectedTypeProduct(type))
        } catch (error) {
            console.log(error)
        }
    }

    const setActionTypeProduct = (state) => {
        try {
            dispatch(setAction(state))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        //states
        typeProducts,
        typeProductSelected,
        status,
        action,
        //actions
        getTypeProducts,
        createTypeProduct,
        editTypeProduct,
        deleteTypeProduct,
        setSelectedTypeProduct,
        setActionTypeProduct,
    }
}